<template>
  <div>
    <ion-list-header v-if="vehicles.length > 0">
      <ion-label>{{ $t("bookings.selectVehicle") }}</ion-label>
    </ion-list-header>
    <div
      class="alert-non"
      v-if="vehicles.length === 0"
      text
      type="warning"
      icon="mdi-calendar-remove"
    >
      {{ $t("bookings.noVehicles") }}
    </div>
    <ion-list v-if="vehicles.length > 0">
      <div class="list-item" :class="{'selected': vehicle.id == selectedVehicleTypeId, 'hidden': hideNonSelected && vehicle.id !== selectedVehicleTypeId}" v-for="vehicle of vehicles" :key="vehicle.id" @click="selectedVehicleTypeId = vehicle.id">
        <img :src="vehicle.image" />
        <div>
          {{ vehicle.name }}
        </div>
        <div class="price">
          {{ $filters.toCurrency(vehicle.price) }}
        </div>
      </div>
    </ion-list>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";
import { IonList, IonLabel } from "@ionic/vue";

export default defineComponent({
  components: {
    IonList,
    IonLabel,
  },
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
    dates: {
      required: false,
      type: Object,
    },
    guest: {
      required: false,
      type: Boolean,
    },
    step: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      vehicles: [],
      selectedVehicleTypeId: null,
      hideNonSelected: false,
    };
  },
  watch: {
    dates: {
      deep: true,
      handler(newDates) {
        if (newDates.start !== null) {
          this.getAvailableVehicles();
        }
      },
    },
    selectedVehicleTypeId(newVal) {
      this.$emit("update:modelValue", newVal);
      this.$emit("valid", 2, true);
    },
    step(curretStep, prevStep) {
      // if (curretStep === 2) {
      //   if (this.guest && prevStep === 1 && this.vehicles.length > 0) {
      //     this.setChecked(true, this.vehicles[0]);
      //     this.$emit("continue");
      //   }
      //   if (this.guest && prevStep === 3 && this.vehicles.length > 0) {
      //     this.$emit("back");
      //   }
      // }
    },
  },
  methods: {
    getAvailableVehicles() {
      if (this.dates.start === null || this.dates.end === null) return;

      axios.post("/bookings/vehicle-types", this.dates).then((resp) => {
        this.selectedVehicles = [];
        this.vehicles = resp.data.data;

        if (this.$route.query.vehicle_type_id !== undefined) {
          this.selectedVehicleTypeId = parseInt(this.$route.query.vehicle_type_id);
          this.hideNonSelected = true;
        }
      });
    },
    setChecked($event, vehicle) {
      vehicle.isChecked = $event;
      this.selectedVehicles = this.vehicles.filter((vehicle) => {
        return vehicle.isChecked;
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.v-list-item__action {
  margin-right: 16px;
}
.list-item {
  text-align: center;
    font-size: 20px;
    font-weight: 500;
    background: transparent;
    margin: 6px 24px;
    padding: 12px;
    border: 1px solid #ececec;
    border-radius: 8px;
    cursor: pointer;
  img {
    width: 70%;
  }
  &.selected {
    background-color: #f0f9ff;
    border-color: #0c5a86;
  }
}
.v-avatar {
  margin: 0 14px 0 -16px;
}
.alert-non {
  background: #f7f7cf;
  color: #7a630e;
  font-weight: 500;
  padding: 20px;
  margin: 30px 16px;
  width: 95%;
  z-index: 1;
}
.color {
  width: 18px;
  height: 18px;
  display: inline-block;
  position: relative;
  top: 10px;
  margin-right: 5px;
  float: right;
  border-radius: 10px;
}
.hidden {
  display: none;
}
</style>
